import React from "react";
import { SectionDivider } from "@silversea-ssc/ui-components-react";
import { PageBuilderDividerWithCtaFragment } from "types/graphql-types";
import { BackgroundColor } from "types/componentBackground";
import PageBuilderButtonCTA from "./PageBuilderButtonCTA";
import { graphql } from "gatsby";

export interface PageBuilderDividerWithCTAProps
  extends PageBuilderDividerWithCtaFragment {
  backgroundColorTop?: BackgroundColor;
  backgroundColorBottom?: BackgroundColor;
  className?: string;
}

const PageBuilderDividerWithCTA: React.FC<
  React.PropsWithChildren<PageBuilderDividerWithCTAProps>
> = (props) => (
  <SectionDivider
    backgroundColorTop={props.backgroundColorTop}
    backgroundColorBottom={props.backgroundColorBottom}
    className={props.className}
    dataContentName="divider_with_cta"
  >
    {props.ctaButtons?.map((b) => (
      <PageBuilderButtonCTA key={b?._key} {...b} />
    ))}
  </SectionDivider>
);

export default PageBuilderDividerWithCTA;

export const fragments = graphql`
  fragment PageBuilderDividerWithCTA on SanityDividerWithCTA {
    _key
    ctaButtons {
      ...ButtonCTA
    }
  }
`;
